/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Successful response
 * @export
 * @interface GetCollectorLicense200Response
 */
export interface GetCollectorLicense200Response {
    /**
     * 
     */
    subscriptionStatus?: string;
    /**
     * 
     */
    currentPeriodEnd?: number;
    /**
     * 
     */
    username?: string;
    /**
     * 
     */
    password?: string;
    /**
     * 
     */
    mode?: string;
    /**
     * 
     */
    sleepForMs?: number;
}

/**
 * Check if a given object implements the GetCollectorLicense200Response interface.
 */
export function instanceOfGetCollectorLicense200Response(value: object): value is GetCollectorLicense200Response {
    return true;
}

export function GetCollectorLicense200ResponseFromJSON(json: any): GetCollectorLicense200Response {
    return GetCollectorLicense200ResponseFromJSONTyped(json, false);
}

export function GetCollectorLicense200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCollectorLicense200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'subscriptionStatus': json['subscriptionStatus'] == null ? undefined : json['subscriptionStatus'],
        'currentPeriodEnd': json['currentPeriodEnd'] == null ? undefined : json['currentPeriodEnd'],
        'username': json['username'] == null ? undefined : json['username'],
        'password': json['password'] == null ? undefined : json['password'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'sleepForMs': json['sleepForMs'] == null ? undefined : json['sleepForMs'],
    };
}

export function GetCollectorLicense200ResponseToJSON(json: any): GetCollectorLicense200Response {
    return GetCollectorLicense200ResponseToJSONTyped(json, false);
}

export function GetCollectorLicense200ResponseToJSONTyped(value?: GetCollectorLicense200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subscriptionStatus': value['subscriptionStatus'],
        'currentPeriodEnd': value['currentPeriodEnd'],
        'username': value['username'],
        'password': value['password'],
        'mode': value['mode'],
        'sleepForMs': value['sleepForMs'],
    };
}

